import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-thumbs-prompt",
  templateUrl: "./thumbs-prompt.component.html",
  styleUrls: ["./thumbs-prompt.component.scss"],
})
export class ThumbsPromptComponent {
  @Input() businessName = "";
  @Input() businessLogo: string | null = null;
  // Recipient's name from the invite; absent for anonymous slugs, in which case
  // the greeting line is hidden.
  @Input() contactName: string | null = null;
  @Input() welcomeMessage = "";
  // Disabled while the parent records the vote.
  @Input() busy = false;
  @Output() picked = new EventEmitter<"up" | "down">();

  // Highlights the tapped card until the parent swaps the step out.
  sentiment: "positive" | "negative" | null = null;

  pick(which: "up" | "down"): void {
    if (this.busy) return;
    this.sentiment = which === "up" ? "positive" : "negative";
    this.picked.emit(which);
  }
}
